import clsx from 'clsx';

const variants = {
  default: 'bg-brand-teal/10 text-brand-teal border border-brand-teal/30',
  warning: 'bg-amber-200/30 text-amber-700 border border-amber-400/40',
  danger: 'bg-red-100 text-red-600 border border-red-200/60',
  outline: 'border border-slate-400 text-slate-700 dark:text-slate-300 dark:border-slate-600',
};

export function Badge({ className, variant = 'default', children }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide',
        variants[variant] || variants.default,
        className,
      )}
    >
      {children}
    </span>
  );
}

export default Badge;
